
import { useOutletContext } from "react-router-dom";
export default function useHttpUtility(hideErrors = false) {

    const [showNotification] = useOutletContext();

    return {
        get: async function (uri, onSuccess, onError) {
            return await fetch(uri)
                .then(async (response) => {
                    switch (response.status) {
                        case 200:
                        case 201:
                            if (!onSuccess)
                                return;

                            let data = await response.json();
                            onSuccess(data);
                            break;
                        default:
                            let dataError = await response.json();
                            let errors = dataError?.errors?.length > 0
                                ? dataError.errors
                                : [`Bad response from server with status ${response.status}.`];

                            if (!hideErrors)
                                showNotification(2, errors[0]);

                            if (onError)
                                onError(errors);

                            break;
                    }
                })
                .catch(error => {
                    console.log(error);
                    let errors = ["Bad response from server"];

                    if (!hideErrors)
                        showNotification(2, errors[0]);

                    if (onError)
                        onError(errors);
                });
        },
        post: async function (uri, data, onSuccess, onError) {
            return await fetch(
                uri,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                }
            )
                .then(async (response) => {
                    switch (response.status) {
                        case 200:
                        case 201:
                            if (!onSuccess)
                                return;

                            let data = await response.json();
                                
                            onSuccess(data);
                            break;
                        default:
                            let dataError = await response.json();
                            let errors = dataError?.errors?.length > 0
                                ? dataError.errors
                                : [`Bad response from server with status ${response.status}.`];

                            if (!hideErrors)
                                showNotification(2, errors[0]);

                            if (onError)
                                onError(errors);

                            break;
                    }
                })
                .catch(error => {
                    console.log(error);
                    let errors = ["Bad response from server"];

                    if (!hideErrors)
                        showNotification(2, errors[0]);

                    if (onError)
                        onError(errors);
                });
        },
        delete: async function (uri, onSuccess, onError) {
            return await fetch(
                uri,
                {
                    method: 'DELETE'
                }
            )
                .then(async (response) => {
                    switch (response.status) {
                        case 200:
                        case 201:
                            if (!onSuccess)
                                return;

                            onSuccess();
                            break;
                        default:
                            let data = await response.json();
                            let errors = data?.errors?.length > 0 ? data.errors : [`Bad response from server with status ${response.status}.`];

                            if (!hideErrors)
                                showNotification(2, errors[0]);

                            if (onError)
                                onError(errors);
                    }
                })
                .catch(error => {
                    console.log(error);
                    let errors = ["Bad response from server"];

                    if (!hideErrors)
                        showNotification(2, errors[0]);

                    if (onError)
                        onError(errors);
                });
        }
    };
};